import { render } from "./ComponentField.vue?vue&type=template&id=368d4ea4&ts=true"
import script from "./ComponentField.vue?vue&type=script&lang=ts"
export * from "./ComponentField.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__